<div class="images">
	{{#each frames}}<img src="{{getPreviewUrl image}}" class="hidden" data-frame="{{@index}}">{{/each}}
</div>
